import rdf from '@ontologies/core';
// @ts-ignore
import NdjsonStream from 'can-ndjson-stream';
import { createLineParser } from './createLineParser';
import { hextupleStringParser } from './hextupleStringParser';
let hasReadableStreamConstructor = false;
try {
    // tslint:disable-next-line:typedef no-empty no-unused-expression
    new ReadableStream({ start() { } });
    hasReadableStreamConstructor = true;
}
catch (e) {
    // ignore
}
export const hextuplesTransformer = async (res, rdfFactory = rdf) => {
    const delta = [];
    let parse;
    if (res instanceof Response && hasReadableStreamConstructor) {
        const stream = new NdjsonStream(res.body);
        const reader = stream.getReader();
        const lineToQuad = createLineParser(rdfFactory);
        let read;
        parse = reader
            .read()
            .then(read = (result) => {
            if (result.done) {
                return;
            }
            delta.push(lineToQuad(result.value));
            return reader.read().then(read);
        });
    }
    else {
        let body;
        if (res instanceof Response) {
            body = res.text();
        }
        else if (typeof XMLHttpRequest !== "undefined"
            && res instanceof XMLHttpRequest
            || typeof res.responseText === "string") {
            body = Promise.resolve(res.responseText);
        }
        else {
            if (typeof res.body !== "string") {
                throw Error("Unsupported input format");
            }
            body = Promise.resolve(res.body);
        }
        parse = body
            .then((text) => {
            delta.push(...hextupleStringParser(text));
        });
    }
    await parse;
    return delta;
};
